import _ from 'underscore';

export function isEditing(schema, model) {
  let editing = !_.isEmpty(model);

  if (schema.key) {
    // more strict for schema with key
    editing = editing && model[schema.key];
  }

  return editing;
}

export function isFieldEditing(field, model) {
  if (field.hasSubFields) {
    return _.some(field.fields, (subField) => {
      return isFieldEditing(subField, model); //it can be optimized here for performance issue, anyway, if we find performance issue, will update it
    });
  } else {
    return !_.chain(model)
      .result(field.property)
      .isEmpty()
      .value();
  }
}
